import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.purchase-license', {
        url: '/purchase',
        component: 'purchaseLicense',
        resolve: {},
    });
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/purchase-license/purchase-license.state.js